module.exports = __webpack_public_path__ + "static/media/Marketplace.53345a76.svg";